module.exports = __webpack_public_path__ + "static/media/joussour.8b1e8549.png";